import { TextInput, Button, Space, createStyles, Text, Alert, Group, Center } from '@mantine/core';
import { useForm } from '@mantine/form';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useState } from 'react';
import {  validateEmail, beigeColor } from '../../assets/constants';
import { resetPassword } from '../../utils/firebase/firebase.utils';
import FormPaper from '../../components/form-paper/form-paper.component';
import LogoWithText from '../../components/logo-with-text/logo-with-text.component';

const useStyles = createStyles((theme) => ({
    outerContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: beigeColor,
        [theme.fn.smallerThan('xs')]: {
            alignItems: 'start',
            background: 'white'
        }
    },

    formContainer: {
        width: '100%',
        maxWidth: '460px',
    },

    submitButton: {
        width: '100%'
    },

    mobileOnly: {
        [theme.fn.largerThan('sm')]: {
            display: 'none',
        }
    },

    linkText: {
        textDecoration: 'none',
        fontWeight: 500,
        color: '#1959b0',
        '&:hover': {
            textDecoration: 'underline',
        }
    }


}));

const ForgotPassword = () => {

    const [formSubmitting, setFormSubmitting] = useState(false);
    const [resetProblem, setResetProblem] = useState(false);
    const [resetSuccess, setResetSuccess] = useState(false);

    const { classes } = useStyles();


    const form = useForm({
        initialValues: {
            email: '',
        },

        validate: {
            email: (value) => validateEmail(value) ? null : 'Invalid email',
        },

    });

    const resetHandler = async (event) => {
        setResetProblem(false);
        setResetSuccess(false);
        event.preventDefault();
        form.validate();
        if (form.isValid()) {
            setFormSubmitting(true);
            try {
                await resetPassword(form.values.email);
                setResetSuccess(true);
            } catch (error) {
                if (error.code === 'auth/user-not-found') {
                    form.setFieldError('email', "Couldn't find an account with that email");
                } else {
                    setResetProblem(true);
                }
            }
        }
        setFormSubmitting(false);
    }


    return (
        <>
            <Helmet>
                <title>Password reset | Roundtable</title>
                <meta
                    name='description'
                    content='Forgot your password to your Roundtable account? Reset it here.'
                />
            </Helmet>
            <div className={classes.outerContainer}>
                <div className={classes.formContainer}>
                    <FormPaper>
                        <Space h='lg' className={classes.mobileOnly} />
                        <Center>
                        <LogoWithText innerWidth = {200} innerHeight = {0} opacity={1} logoScalingFactor={1.1}/>
                        </Center>
                        <Space h='lg' />
                        <Text align="center" size='lg' weight={400}>Reset your password</Text>
                        <Space h='md' />
                        {
                            resetSuccess &&
                            <>
                                <Space h='md' />
                                <Alert title="Success" color="teal" radius='lg'>An email was sent to your account with instructions for resetting your password.
                                    If you don't receive an email in 5 minutes, please resubmit this form.</Alert>
                                <Space h='md' />
                            </>
                        }
                        <form name='sign-in' onSubmit={(event) => resetHandler(event)}>
                            <TextInput
                                withAsterisk={false}
                                name='email'
                                required
                                label="Email"
                                {...form.getInputProps('email')}
                                size='md'
                                radius = 'md'
                            />
                            <Space h='lg' />
                            <Button
                                type='submit'
                                size='lg'
                                radius = 'md'
                                className={classes.submitButton}
                                loading={formSubmitting}
                            >
                                {formSubmitting ? '' : 'Reset password'}
                            </Button>
                        </form>
                        <Space h='lg' />
                        <Group position='center'>
                            <Text
                                className={classes.linkText}
                                component={Link} to='/sign-in'
                            >
                                Back to sign-in page
                            </Text>
                        </Group>
                    </FormPaper>
                    {
                        resetProblem &&
                        <>
                            <Space h='md' />
                            <Alert title="Oops!" color="red" radius='lg'>There was a problem resetting your password. Please try again or <a href='mailto:support@roundtable.ai' target='_blank'>contact support</a>.</Alert>
                            <Space h='md' />
                        </>
                    }
                </div>
            </div>
        </>
    );
}

export default ForgotPassword;